import React, { useState, useRef, useEffect } from "react";
import useMediaDataAndTabs from "../commonV3/hooks/useMediaDataAndTabs";

const imageLoadTracker = {
  imageLoadTimes: [],
  imageLoadCount: 0,
  hasReported: false, 
  avgLoadTime: null, 
  onCompleteCallback: null 
};

export const getImageLoadingAnalytics = () => {
  if (imageLoadTracker.hasReported && imageLoadTracker.avgLoadTime !== null) {
    return {
      imageLoadTime: imageLoadTracker.avgLoadTime,
      imageCount: imageLoadTracker.imageLoadCount
    };
  }
  return null;
};

export const setImageLoadingCompleteCallback = (callback) => {
  imageLoadTracker.onCompleteCallback = callback;
};

const ImageWithShimmer = React.memo(({
  src,
  alt,
  className,
  enableZoom = false,
  imageWithShimmerRef,
  handleMouseDown,
  handleTouchStart,
  handleTouchMove,
  imageStyle = '',
  shouldStartLoading = '',
  isShimmerItem = false,
}) => {
  const [showLoading, setShowLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [loadStartTime, setLoadStartTime] = useState(null);
  const localRef = useRef(null);
    // Use provided ref or fallback to local ref
  const ref = imageWithShimmerRef || localRef;

  useEffect(() => {
    // If it's a shimmer item, don't load the actual image, just show shimmer
    if (isShimmerItem) {
      setShowLoading(true);
      setImageSrc(null);
      return;
    }
    
    if (shouldStartLoading !== '' && shouldStartLoading === 'eager') {
      setImageSrc(src);
      setLoadStartTime(Date.now());
    }else if(shouldStartLoading === ''){
      setImageSrc(src);
      setLoadStartTime(Date.now());
    }
  }, [shouldStartLoading, src, isShimmerItem]);
 
  const handleDataError = () => {
    setShowLoading(false);
    setHasError(true);
  };

  const handleImageLoad = () => {
    const loadEndTime = Date.now();
    const loadTime = loadEndTime - loadStartTime;
    
    setShowLoading(false);
    
    if (imageLoadTracker?.imageLoadCount < 8 && !imageLoadTracker?.hasReported) {
      imageLoadTracker.imageLoadTimes.push(loadTime);
      imageLoadTracker.imageLoadCount++;
      
      if (imageLoadTracker?.imageLoadCount === 8) {
        const avgLoadTime = imageLoadTracker?.imageLoadTimes?.reduce((sum, time) => sum + time, 0) / imageLoadTracker?.imageLoadTimes?.length;
        imageLoadTracker.avgLoadTime = avgLoadTime;
        imageLoadTracker.hasReported = true;
        if (imageLoadTracker?.onCompleteCallback) {
          imageLoadTracker.onCompleteCallback();
        }
      }
    }
  };

  return (
    <div className="relative w-full h-full bg-gray-100" ref={ref}>
      {(imageSrc) && (
        <img
          onLoad={handleImageLoad}
          onError={handleDataError}
          src={imageSrc}
          alt={alt}
          className={`${className} transition-opacity duration-300`}
          style={{
            ...imageStyle,
            touchAction: enableZoom ? 'none' : 'auto',
          }}
          onMouseDown={enableZoom ? handleMouseDown : () => { }}
          onTouchStart={enableZoom ? handleTouchStart : () => { }}
          onTouchMove={enableZoom ? handleTouchMove : () => { }}
          draggable="false"
        />
      )}

      {(showLoading ) && (
        <div className='rounded-lg absolute inset-0 h-full object-cover aspect-video shimmer w-full flex items-center justify-center border text-gray-500 text-xl'></div>
      )}

      {hasError && (
        <div className='rounded-lg absolute inset-0 h-full object-cover aspect-video shimmer w-full flex items-center justify-center border text-gray-500 text-xl'></div>
      )}
    </div>
  );
});

export default ImageWithShimmer;